// removed by extract-text-webpack-plugin
module.exports = {"icon":"styles__icon___1_3yJ","actions":"styles__actions___3YTfz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccessDeniedModal/styles.css
// module id = 2568
// module chunks = 0